var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Translate } from "../../I18N";
import React, { useState, useEffect } from 'react';







const ImageViewer = ({ alt, src, className }) => {
  const [imageExists, setImageExists] = useState(null);
  const [errorFlag, setErrorFlag] = useState(false);

  useEffect(() => {
    const checkImageExists = async (url) => {
      try {
        const response = await fetch(url, { method: 'GET' });
        setImageExists(Boolean(response.ok));
      } catch (error) {
        setImageExists(false);
      }
    };

    // eslint-disable-next-line no-void
    void checkImageExists(src);
  }, [src]);
  if (imageExists === false) {
    return (/*#__PURE__*/
      _jsx("div", { className: "media-error" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Image not found")
      ));

  }

  if (errorFlag) {
    return (/*#__PURE__*/
      _jsx("div", { className: "media-error" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This file type is not supported on media fields")
      ));

  }

  if (imageExists === null) {
    return /*#__PURE__*/_jsx(Translate, {}, void 0, "Loading");
  }

  return /*#__PURE__*/_jsx("img", { className: className, src: src, onError: () => setErrorFlag(true), alt: alt });
};

export { ImageViewer };